import { IcoMain } from "./Icons";

export default function Header() {
  return (
    <header>
      <IcoMain /> <h1>My ToDo List</h1>
    </header>
  );
}
